import React, { useState } from 'react';

import { RecipeCommunityType } from '../../../../type/recipe';
import { chevron_bottom_gray700_24x24 } from '../../../../utils/common/variables';
import { Z_INDEX } from '../../../../utils/common/zIndex';
import BottomSheet from '../components/BottomSheet';
import RecipeCommentContainerV2 from '../components/RecipeCommentContainerV2';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsCommentBottomSheet = () => {
  const { diary, showComments, setShowComments } = useDiaryShortsContext();

  const [totalCommentCount, setTotalCommentCount] = useState(0);

  if (!showComments) return null;

  return (
    <BottomSheet
      height="auto"
      maxHeight="80vh"
      onClose={() => setShowComments(false)}
      hasButton={false}
      paddingTop={8}
      paddingBottom={16}
      zIndex={Z_INDEX.DIARY_SHORTS.COMMENT}
    >
      <div className="relative">
        <RecipeCommentContainerV2
          totalCommentCount={totalCommentCount}
          setTotalCommentCount={setTotalCommentCount}
          headerType="STICKY"
          type={RecipeCommunityType.DIARY}
          diaryId={diary.id}
        />
        <button
          onClick={() => setShowComments(false)}
          className="flex-center fixed top-8px right-0 z-[2] h-56px w-56px"
          type="button"
        >
          <img src={chevron_bottom_gray700_24x24} alt="댓글 닫기" />
        </button>
      </div>
    </BottomSheet>
  );
};

export default _DiaryShortsCommentBottomSheet;
